import appetite from './icons/appetite.vue';
import breath from './icons/breath.vue';
import comment from './icons/comment.vue';
import calendar from './icons/calendar.vue';
import pulse from './icons/pulse.vue';
import addANote from './icons/addANote.vue';
import bodyMass from './icons/bodyMass.vue';
import boldPlus from './icons/boldPlus.vue';
import detector from './icons/detector.vue';
import heartHealth from './icons/heartHealth.vue';
import manRunning from './icons/manRunning.vue';
import ManSelfTraining from './icons/ManSelfTraining.vue';
import save from './icons/save.vue';
import shared from './icons/shared.vue';
import verifiedCard from './icons/verifiedCard.vue';
import slimPlus from './icons/slimPlus.vue';
import sleep from './icons/sleep.vue';
import removeCross from './icons/removeCross.vue';
import square from './icons/square.vue';
import duration from './icons/duration.vue';
import reward from './icons/reward.vue';
import manExercise from './icons/manExercise.vue';
import findInBook from './icons/findInBook.vue';
import openBook from './icons/openBook.vue';
import searchGlass from './icons/searchGlass.vue';
import arrowDown from './icons/arrowDown.vue';
import redAlertTriangle from './icons/redAlertTriangle.vue';
import errorCircleSlim from './icons/errorCircleSlim.vue';
import approvedAcceptSlim from './icons/approvedAcceptSlim.vue';
import editCircleSlim from './icons/editCircleSlim.vue';
import eye from './icons/eye.vue';
import book from './icons/book.vue';
import calendarNew from './icons/calendarNew.vue';
import arrowLeft from './icons/arrowLeft.vue';
import nextArrow from './icons/nextArrow.vue';
import prevArrow from './icons/prevArrow.vue';
import person from './icons/person.vue';
import heart from './icons/heart.vue';
import plusNew from './icons/plus-new.vue';
import runningHuman from './icons/runningHuman.vue';
import alert from './icons/alert.vue';
import trash from './icons/trash.vue';
import upload from './icons/upload.vue';
import close from './icons/close.vue';
import apply from './icons/apply.vue';
import fileAdd from './icons/fileAdd.vue';
import mapMark from './icons/mapMark.vue';
import list from './icons/list.vue';
import down from './icons/down.vue';
import arrowUp from './icons/arrow_up.vue';
import closedEye from './icons/closed_eye.vue';
import question from './icons/question.vue';
import cabinet from './icons/cabinet.vue';
import trainerRecommendations from './icons/trainerRecommendations.vue';
import mentoring from './icons/mentoring.vue';
import notifications from './icons/notifications.vue';
import settings from './icons/settings.vue';
import phone from './icons/phone.vue';
import email from './icons/email.vue';
import slidePrev from './icons/slidePrev.vue';
import slideNext from './icons/slideNext.vue';
import logo from './icons/logo.vue';
import glasses from './icons/glasses.vue';
import roundedCheckmark from './icons/rounded-checkmark.vue';
import roundedPlus from './icons/rounded-plus.vue';
import graduateCap from './icons/graduate-cap.vue';
import vk from './icons/vk.vue';
import telegram from './icons/telegram.vue';
import rutube from './icons/rutube.vue';
import dzen from './icons/dzen.vue';
import odnoklassniki from './icons/odnoklassniki.vue';

export const uiIcons = {
  addANote,
  alert,
  apply,
  approvedAcceptSlim,
  arrowDown,
  arrowLeft,
  arrowUp,
  bodyMass,
  boldPlus,
  book,
  breath,
  calendar,
  cabinet,
  calendarNew,
  close,
  closedEye,
  comment,
  detector,
  down,
  duration,
  editCircleSlim,
  email,
  errorCircleSlim,
  eye,
  fileAdd,
  findInBook,
  glasses,
  heart,
  heartHealth,
  list,
  logo,
  manExercise,
  manRunning,
  ManSelfTraining,
  mapMark,
  mentoring,
  nextArrow,
  notifications,
  openBook,
  person,
  phone,
  plusNew,
  prevArrow,
  pulse,
  question,
  redAlertTriangle,
  removeCross,
  reward,
  runningHuman,
  save,
  searchGlass,
  shared,
  sleep,
  slimPlus,
  slidePrev,
  slideNext,
  square,
  settings,
  trainerRecommendations,
  trash,
  upload,
  verifiedCard,
  appetite,
  roundedCheckmark,
  roundedPlus,
  graduateCap,
  vk,
  dzen,
  rutube,
  telegram,
  odnoklassniki,
};



// WEBPACK FOOTER //
// ./src/uikit/components/AppSvgIconNew/templates/index.ts